import React from 'react';
import ReactDOM from 'react-dom/client';
import Application from './Application';

const rootElement = document.getElementById('root');
if (rootElement) {
    ReactDOM.createRoot(rootElement).render(React.createElement(Application, null));
}
